import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React from 'react'
import { toJS } from 'mobx'

import FormSection from '../../shared/components/FormSection'
import FileInput from '../../shared/components/FileInput'
import ImageInput from '../../shared/components/ImageInput'

const renderImages = (all, index, item, _disabled, onImageChange) => (
  <ImageInput
    all={all}
    index={index}
    item={item}
    onChange={onImageChange}
  />
)

const MediaFormSection = ({
  show,
  links,
  images,
  onChange,
  readOnly,
  fieldSpecs
}) => {

  return (
    <FormSection
      title="5. Media-Daten"
      show={show}
    >

      <FileInput
        onChange={onChange}
        name="links"
        accept="application/pdf"
        descriptionPlaceholder="Anzeigename"
        value={toJS(links)}
        className="files"
        disabled={readOnly}
        {...fieldSpecs.links}
      />

      <FileInput
        onChange={onChange}
        name="images"
        accept="image/pjpeg,image/jpeg,image/png"
        descriptionPlaceholder="Bildbeschreibung"
        value={toJS(images)}
        renderChildren={renderImages}
        className="images"
        disabled={readOnly}
        {...fieldSpecs.media}
      />

    </FormSection>
  )
}

MediaFormSection.propTypes = {
  fieldSpecs: PropTypes.object,
  images: MobXPropTypes.observableArray,
  links: MobXPropTypes.observableArray,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  show: PropTypes.bool,
}

export { MediaFormSection as default }



// WEBPACK FOOTER //
// ./src/museum/components/05-MediaFormSection.js